import React from 'react';
interface Props {
  data: any;
}
function Dates({ data }: Props) {
  return (
    <div className='ubbe-card h-100'>
      <div className='ubbe-card-header'>
        <h5 className='ps-3 mb-0 GlobalBoxHead'>Dates</h5>
      </div>
      <div className='card-body pt-2 p-4 h-auto'>
        <div className='row'>
          <div className='col-md-6'>
            <span className='global-text-16'>Accepted Date
            </span>
          </div>
          <div className='col-md-6 boldglobaltext text-break'>
            {data?.accepted_date ? data?.accepted_date : 'N/A'}
          </div>
        </div>
        <div className='row mt-2'>
          <div className='col-md-6'>
            <span className='global-text-16'>Received Date

            </span>
          </div>
          <div className='col-md-6 boldglobaltext text-break'>
            {data?.received_date ? data?.received_date : 'N/A'}
          </div>
        </div>
        <div className='row mt-2'>
          <div className='col-md-6'>
            <span className='global-text-16'>Expiration Date

            </span>
          </div>
          <div className='col-md-6 boldglobaltext text-break'>
            {data?.expiration_date && data?.expiration_date !== '0001-01-01' ? data?.expiration_date : 'N/A'}
          </div>
        </div>


      </div>
    </div>
  );
}

export default Dates;
